<template>
  <div class="result">
    <v-base-card>
      <template v-slot:heading>
        <div class="result-heading">
          <p class="result-heading__text">{{printTitle}} プレビュー</p>
        </div>
      </template>

      <template v-slot:content>
        <v-section-panel useBreak>
          <template v-slot:content>
            <v-container fluid>
              <v-row>
                <v-col cols=12>
                  <v-result-table ref="result-table"/>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-section-panel>

        <!-- 確定ボタン -->
        <p class="message" v-if="isSampleAccount">サンプルでは問題の保存はできません</p>
        <v-btn class="mr-2" color="gray" v-if="!savePrintMode" @click="retake()">やりなおす</v-btn>
        <v-btn class="mr-2" color="gray" v-if="savePrintMode" @click="$router.go(-1)">戻る</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('questions')">問題ダウンロード</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('answers')">解答ダウンロード</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('explanations')" v-if="isDiscription">解説ダウンロード</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('all')">すべてダウンロード</v-btn>
        <v-btn class="mr-2"
          :dark="!isSampleAccount"
          :color="!isSampleAccount ? '#2bb8d3' : ''"
          v-if="!savePrintMode"
          :disabled="isSampleAccount"
          @click="storedNameDialog = true">
          保存する
        </v-btn>


        <v-section-panel class="mt-5" useBreak>
          <template v-slot:title>
            問題
          </template>
          <template v-slot:content>
            <v-preview-area :previewImages="printData.questionImageUrls" />
          </template>
        </v-section-panel>

        <v-section-panel useBreak>
          <template v-slot:title>
            解答
          </template>
          <template v-slot:content>
            <v-preview-area :previewImages="printData.answerImageUrls" />
          </template>
        </v-section-panel>

        <v-section-panel useBreak v-if="isDiscription">
          <template v-slot:title>
            解説
          </template>
          <template v-slot:content>
            <v-preview-area :previewImages="printData.explanationImageUrls" />
          </template>
        </v-section-panel>

        <!-- 確定ボタン -->
        <p class="message" v-if="isSampleAccount">サンプルでは問題の保存はできません</p>
        <v-btn class="mr-2" color="gray" v-if="!savePrintMode" @click="retake()">やりなおす</v-btn>
        <v-btn class="mr-2" color="gray" v-if="savePrintMode" @click="$router.go(-1)">戻る</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('questions')">問題ダウンロード</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('answers')">解答ダウンロード</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('explanations')" v-if="isDiscription">解説ダウンロード</v-btn>
        <v-btn class="mr-2" color="secondary" @click="pdfDownload('all')">すべてダウンロード</v-btn>
        <v-btn class="mr-2"
          :dark="!isSampleAccount"
          :color="!isSampleAccount ? '#2bb8d3' : ''"
          v-if="!savePrintMode"
          :disabled="isSampleAccount"
          @click="storedNameDialog = true">
          保存する
        </v-btn>
      </template>
    </v-base-card>

    <v-dialog
      v-model="dialog"
      max-width="50%"
    >
      <v-card>
        <v-img
          v-if="dialogImage"
          :src="this.dialogImage"
        />
      </v-card>
    </v-dialog>

    <!-- 保存名ダイアログ -->
    <v-dialog
      v-model="storedNameDialog"
      min-width="35%"
      max-width="320px"
      transition="slide-y-transition"
    >
      <v-card>
      <vue-scroll :ops="ops">
        <v-card-title  class="card-title grey lighten-2">
          保存名
        </v-card-title>
        <v-text-field
          class="input-exam"
          v-model="storedName"
          maxlength="14"
          color="secondary"
          counter="14"
          outlined
          dense
        />
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            dark
            small
            @click.stop="save"
          >
            ok
          </v-btn>
          <v-btn
            color="grey"
            dark
            small
            @click.stop="storedNameDialog = false"
          >
            cancel
          </v-btn>
        </v-card-actions>
      </vue-scroll>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VResultTable from '@/components/molecules/ResultTable'
import VPreviewArea from '@/components/molecules/PreviewArea'
import { saveAs } from 'file-saver'
import VueScroll from 'vuescroll'

export default {
  components: {
    VBaseCard,
    VSectionPanel,
    VResultTable,
    VPreviewArea,
    VueScroll
  },

  data: () => ({
    dialog: false,
    dialogImage: null,
    storedNameDialog: false,
    storedName: null,
    ops: {
      bar: {
        background: 'gray',
      },
    }
  }),

  watch: {
    dialog(now) {
      if (!now) this.dialogImage = null;
    }
  },

  mounted() {
    this.$gtag.pageview({
      page_path: '/saved_print',
      page_title: "プレビュー"
    })
  },

  computed: {
    isSampleAccount() {
      return this.$store.getters['user/isSampleAccount']
    },
    isDiscription() {
      //解説の有無
      return this.printData.explanationImageUrls && this.printData.explanationImageUrls.length > 0
    },
    printTitle() {
      return this.$store.state.conditions.printTitle
    },
    savePrintMode() {
      return this.$store.state.conditions.savePrintMode
    },
    printData() {
      return this.$store.state.conditions.printData
    },
    dialogImages() {
      //PDF画像表示用に整形
      let images = {}
      Object.entries(this.printData).forEach(imageUrls=>{
        if(imageUrls[0]!=='id') { //'id'の場合は処理をスキップ
          let imageType = imageUrls[0]
          imageUrls[1].forEach((imageUrl, index)=>{
            images[imageType+index] = imageUrl
          })
        }
      })
      return images
    },
  },

  methods: {
    async pdfDownload(mode) {
      // PDFダウンロードAPI実行する
      const printId = this.$store.state.conditions.printData.id
      let attachedNames = mode === 'all' ? ['questions', 'answers'] : [mode]
      if (mode==='all' && this.isDiscription) attachedNames.push('explanations')
      const res = await this.$axios(`/api/v1/prints/${printId}/download?id=${printId}&attached_names=${attachedNames}`, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
    retake() {
      //テスト作成画面から再開する(stateの値を参照しているので条件はそのまま引き継がれる)
      this.$router.push('/teacher/create_print')
    },
    showImage(image) {
      this.dialog = !this.dialog;
      this.dialogImage = this.dialogImages[image];
    },
    async save() {
      if(!this.storedName){
        this.$toasted.global.error({ message: '保存名を入力して下さい。' })
        return
      }
      this.storedNameDialog = false
      //保存API用パラメータ作成
      const printId = this.$store.state.conditions.printData.id
      let tableValues = {}
      this.$refs['result-table'].desserts.forEach((d, index) => {
        tableValues[index] = d
      })
      const conditionDetails = {
        id: printId,
        print: {
          stored: true,                                                   //保存フラグ
          storedName: this.storedName ,                                   //保存名
          publisherId: this.$store.state.conditions.selectedSearchType === 1
            ? this.$store.state.conditions.selectedTextbook
            : '',
          gradeId: this.$store.state.conditions.selectedSearchType === 1
            ? this.$store.state.conditions.selectedGrade
            : '',
          conditionDetails: JSON.stringify(tableValues) //抽出条件詳細(json)
        }
      }

      // 問題保存API実行する
      await this.$axios.put('/api/v1/prints/' + printId, conditionDetails)
      .then((res) => {
        if (res.status === 'error') this.$toasted.global.error({ message: res.message })
        else this.$toasted.global.success({ message: '保存しました。' })
      })
      //TODO:500エラー対応
    },
  }
}
</script>

<style lang="stylus" scoped>
.graph-area
  height 400px
  position relative

  &__1
    position absolute
    width 100%
    top -20px

  &__2
    position absolute
    width 100%
    top calc(100% / 4 * 1 - 20px)

  &__3
    position absolute
    width 100%
    top calc(100% / 4 * 2 - 20px)

  &__4
    position absolute
    width 100%
    top calc(100% / 4 * 3 - 20px)

.result-btn
  margin-right 10px

.result-heading
  display inline-block

  &__text
    display inline-block

.input-exam
  margin 10px
  width 300px

.message
  font-size 13px

</style>
